const Generators = {
  RandomizedDepthFirstSearch: 0,
  RandomizedKruskalsAlgorithm: 1,
  RandomizedPrimsAlgorithm: 2,
  WilsonsAlgorithm: 3
};

export default Generators;
